// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> cameron-run
// Generated: 2026-10-01T17:23:36.931Z
// Counts: 3 design, 87 content, 26 slot group, 8 collection binding, 9 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious affordable living apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>1 , 2, and 3 Bedroom Apartments For Rent</h2><h2>Comfort, Convenience &amp; Value — Minutes from Everything Atlanta Has to Offer</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Spacious Apartment Homes in East Point</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in East Point, GA, Cameron Run offers affordable and spacious one, two, and three-bedroom apartment homes in an ideal location.</p><p>You are a short trip to the airport while also being surrounded by vibrant local attractions like Tyler Perry Studios and Camp Creek Marketplace. Unwind at Cascade Springs Nature Preserve, hit a round at Wolf Creek Golf Club, or explore the rich history at Hapeville Depot Museum.</p><p>Embrace a community where convenience meets adventure!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything You Need Is Just Around the Corner</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Cameron Run Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Home to Comfort, Convenience &amp; Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019ddf7f-52b1-719f-8f6c-db2a3cfc7cfd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 24px;\"><strong>Everything You Need To Feel At Home</strong></span></p><p>Life at Cameron Run is designed to make every day a little easier. From spacious apartment homes and modern conveniences to relaxing community amenities and professional on-site management, you'll find everything you need to live comfortably in one convenient location.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>We're Here to Help You Find Your Next Home</strong></span></p><p>At Cameron Run in East Point, GA, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">stylish floor plans</a> and a connected community await your discovery. Have questions or ready to schedule a tour? Our friendly leasing team is here to help you find the apartment that's right for you.</p><p>We look forward to welcoming you home to Cameron Run.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactus.call_label": {
    "overrideType": "VALUE",
    "customValue": "Schedule A Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "contactus.visit_label": {
    "overrideType": "VALUE",
    "customValue": "Find Your New Home Today",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself enjoying spacious apartment homes, lush green spaces and a convenient location.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Shopping &amp; dining to major employers &amp; Hartsfield-Jackson Airport. Everything you need is just minutes from home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Find Your Perfect Floor Plan</strong></span></p><p>Whether you're looking for your first apartment or need extra room to grow, Cameron Run offers spacious one, two, and three-bedroom floor plans thoughtfully designed for comfort, convenience, and everyday living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Picture Yourself Here</strong></span></p><p>At Cameron Run in East Point, GA, vibrant living meets comfort in one, two, and three-bedroom <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">apartments</a>. Envision sunny days spent at the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">swimming pool</a>, evening BBQs under the stars, and tranquil walks through lush landscaping. Picture your new lifestyle and all the amenities waiting for you to enjoy!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Everything You Need, Minutes Away</strong></span></p><p>Nestled in East Point, GA, Cameron Run offers more than just exceptional <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">floor plans</a>. Living at Cameron Run means you're never far from where you need to be. Located just minutes from Hartsfield-Jackson Atlanta International Airport, Camp Creek Marketplace, Downtown Atlanta, and major highways, our community makes commuting, shopping, dining, and entertainment incredibly convenient.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Experiences Outside Your Doorstep in East Point, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cameron Run, we recognize that pets are family. Our pet-friendly <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">apartments</a> in East Point, GA, welcome up to two companions per home, giving them ample space to feel comfortable. Our thoughtfully landscaped grounds offer a pleasant environment for walks and playtime, while <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/neighborhood\">nearby parks</a> add even more options for outdoor fun. For any questions about our pet policy, our leasing team is always happy to assist you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Finding the right apartment isn't just about square footage—it's about finding a place that fits your lifestyle.</p><p>At Cameron Run, you'll find more than just an apartment—you'll find a community designed for everyday living. Enjoy spacious floor plans, affordable housing options, and a convenient East Point location that keeps you close to shopping, dining, major employers, and everything Atlanta has to offer.</p><p>Whether you're working from home, commuting to a local Atlanta area employer, or spending time with family, you'll love coming home to Cameron Run.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.read_more_label": {
    "overrideType": "VALUE",
    "customValue": "<p>Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cameron Run, your ideal East Point, GA haven. Choose from our thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, or three-bedroom floor plans</a> that cater to your unique lifestyle. Seamlessly manage your home by accessing our resident portal to pay rent, schedule maintenance, and elevate your living experience today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cameron Run in East Point, GA, vibrant living awaits with <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">thoughtfully designed one, two, and three-bedroom floor plans</a> tailored for your lifestyle. Schedule a tour today and see what our residents love about calling this community home. Their stories may just inspire your next move!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into comfort at Cameron Run, where modern living meets spacious designs. Choose from our charming <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, or three-bedroom gated apartments</a> in East Point, GA that suit your lifestyle. Ready to envision your new home? Take a virtual tour today and experience the community firsthand!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019f4d36-29cd-717f-8c21-354f290bbd0c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People and dogs enjoying a fenced-in dog park with green grass and trees."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[6].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[6].image_media.alt_text"
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[8].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[8].image_media.alt_text"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-4a05-738d-8850-5a227c317cbe.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019d7430-b356-72d5-9d9b-353ae851e21d.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-6995-7594-97f4-1e4d44fa7021.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167331/019e02b1-44ea-73db-97aa-94df02a941ac.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[13].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[13].image_media.alt_text"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Cameron Run Apartments Community Logo"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[39].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[39].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[30].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[30].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[22].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[22].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[28].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[28].poi_featured_image_media.alt_text"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[20].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[20].image_media.alt_text"
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[9].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[9].image_media.alt_text"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[15].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[15].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_5a73937d-43b2-4757-97f6-6d99327a9b75",
      "custom_776007e8-2b72-4be1-8821-46645d4d81c0",
      "custom_7d517ba2-4ebe-4383-9342-7bfdd84ef549",
      "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "custom_83dfafbb-3b89-4b32-ba5c-8cf9c7609827",
      "custom_3385643e-708e-49a6-bf38-b155c7ec7c3a",
      "custom_ace397ff-8ab0-4150-8708-6171b47be4d7"
    ],
    "orderedIds": [
      "custom_5a73937d-43b2-4757-97f6-6d99327a9b75",
      "custom_770811d5-dfda-4886-a258-47235a1115f3",
      "custom_cfc48237-6fef-4927-864b-0906ef52f44e",
      "custom_0e0c33f5-4980-4cbe-8186-08d5631123e0",
      "custom_6a3884eb-02da-4377-be4d-1689d200e51d",
      "custom_f08df560-16d6-4906-ab3d-30b8edc21552",
      "custom_e19f106f-8772-4deb-966a-f24b7d6dddf9",
      "custom_1495eecb-8019-41b5-9399-d9f4451cd1f5",
      "custom_776007e8-2b72-4be1-8821-46645d4d81c0",
      "custom_7d517ba2-4ebe-4383-9342-7bfdd84ef549",
      "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "custom_83dfafbb-3b89-4b32-ba5c-8cf9c7609827",
      "custom_3385643e-708e-49a6-bf38-b155c7ec7c3a",
      "custom_ace397ff-8ab0-4150-8708-6171b47be4d7",
      "custom_eaefe6d1-a0eb-4878-8539-d5acb8eb19e5",
      "custom_d8f14f29-82a9-447c-a8a4-a9713a3cb9df",
      "custom_96df4395-d48f-44ac-8314-960f930f88dd",
      "custom_073c95ad-911c-4308-955c-0395c3b2c94e",
      "custom_f0086a3e-0406-49b8-9cdf-6db84fd921c9",
      "custom_2e73d6d0-bbc2-4588-b09a-1f8eec68f60e",
      "custom_fdb45100-2e63-45c7-9d5a-4ed12749aa44",
      "custom_543d2fd0-7d7d-4eef-9fcb-1c259ea61ab8"
    ],
    "hiddenIndices": [
      0,
      2,
      3,
      5,
      6,
      7,
      11
    ],
    "ordering": [
      0,
      1,
      20,
      9,
      8,
      10,
      12,
      4,
      2,
      3,
      5,
      6,
      7,
      11,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_7d517ba2-4ebe-4383-9342-7bfdd84ef549"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      2
    ],
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": [
      "custom_e2876f4d-f7d0-4c14-bc6d-af41d28952c2",
      "custom_cc8e15cd-bf7c-43f6-ab67-f6b10d7bb159"
    ],
    "orderedIds": [
      "custom_d1120eef-4389-4d19-9532-29d807b61d5d",
      "custom_dba3cc37-fa07-4810-942d-aa21bdf5d554",
      "custom_a8fcbf74-99ea-4397-888b-bea31b5d3211",
      "custom_abfc0da9-efe9-4a24-8f6a-f9b81e792e1f",
      "custom_7a704fce-6930-45bd-97d9-90f109da4982",
      "custom_86857bf9-c487-4253-a566-a530683bfccd",
      "custom_d2f748d6-ab6f-424b-96b8-71286f001dc4",
      "custom_71be8826-be3b-42e0-aeed-f0c631ac6591",
      "custom_e2876f4d-f7d0-4c14-bc6d-af41d28952c2",
      "custom_cc8e15cd-bf7c-43f6-ab67-f6b10d7bb159"
    ],
    "hiddenIndices": [
      2,
      0
    ],
    "ordering": [
      5,
      9,
      1,
      8,
      3,
      4,
      6,
      7,
      2,
      0
    ],
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "custom_073c95ad-911c-4308-955c-0395c3b2c94e",
      "custom_ace397ff-8ab0-4150-8708-6171b47be4d7",
      "custom_2e73d6d0-bbc2-4588-b09a-1f8eec68f60e",
      "custom_fdb45100-2e63-45c7-9d5a-4ed12749aa44",
      "custom_eaefe6d1-a0eb-4878-8539-d5acb8eb19e5"
    ],
    "orderedIds": [
      "custom_770811d5-dfda-4886-a258-47235a1115f3",
      "custom_cfc48237-6fef-4927-864b-0906ef52f44e",
      "custom_83dfafbb-3b89-4b32-ba5c-8cf9c7609827",
      "custom_eaefe6d1-a0eb-4878-8539-d5acb8eb19e5",
      "custom_fdb45100-2e63-45c7-9d5a-4ed12749aa44",
      "custom_2e73d6d0-bbc2-4588-b09a-1f8eec68f60e",
      "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "custom_ace397ff-8ab0-4150-8708-6171b47be4d7",
      "custom_073c95ad-911c-4308-955c-0395c3b2c94e"
    ],
    "hiddenIndices": [
      1,
      5,
      3,
      6,
      7,
      4
    ],
    "ordering": [
      0,
      8,
      2,
      4,
      7,
      6,
      1,
      3,
      5
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_776007e8-2b72-4be1-8821-46645d4d81c0",
      "custom_1495eecb-8019-41b5-9399-d9f4451cd1f5",
      "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "custom_ace397ff-8ab0-4150-8708-6171b47be4d7",
      "custom_eaefe6d1-a0eb-4878-8539-d5acb8eb19e5",
      "custom_d8f14f29-82a9-447c-a8a4-a9713a3cb9df",
      "custom_073c95ad-911c-4308-955c-0395c3b2c94e",
      "custom_f0086a3e-0406-49b8-9cdf-6db84fd921c9",
      "custom_2e73d6d0-bbc2-4588-b09a-1f8eec68f60e",
      "custom_fdb45100-2e63-45c7-9d5a-4ed12749aa44"
    ],
    "orderedIds": [
      "custom_770811d5-dfda-4886-a258-47235a1115f3",
      "custom_96df4395-d48f-44ac-8314-960f930f88dd",
      "custom_0e0c33f5-4980-4cbe-8186-08d5631123e0",
      "custom_6a3884eb-02da-4377-be4d-1689d200e51d",
      "custom_f08df560-16d6-4906-ab3d-30b8edc21552",
      "custom_e19f106f-8772-4deb-966a-f24b7d6dddf9",
      "custom_5a73937d-43b2-4757-97f6-6d99327a9b75",
      "custom_7d517ba2-4ebe-4383-9342-7bfdd84ef549",
      "custom_3385643e-708e-49a6-bf38-b155c7ec7c3a",
      "custom_2e73d6d0-bbc2-4588-b09a-1f8eec68f60e",
      "custom_fdb45100-2e63-45c7-9d5a-4ed12749aa44",
      "custom_cfc48237-6fef-4927-864b-0906ef52f44e",
      "custom_543d2fd0-7d7d-4eef-9fcb-1c259ea61ab8",
      "custom_83dfafbb-3b89-4b32-ba5c-8cf9c7609827",
      "custom_776007e8-2b72-4be1-8821-46645d4d81c0",
      "custom_1495eecb-8019-41b5-9399-d9f4451cd1f5",
      "custom_0d69b6ac-2fdd-4375-967b-1109c388655f",
      "custom_ace397ff-8ab0-4150-8708-6171b47be4d7",
      "custom_eaefe6d1-a0eb-4878-8539-d5acb8eb19e5",
      "custom_d8f14f29-82a9-447c-a8a4-a9713a3cb9df",
      "custom_073c95ad-911c-4308-955c-0395c3b2c94e",
      "custom_f0086a3e-0406-49b8-9cdf-6db84fd921c9"
    ],
    "hiddenIndices": [
      2,
      4,
      5,
      11,
      13,
      14,
      16,
      17,
      18,
      19
    ],
    "ordering": [
      1,
      15,
      9,
      8,
      10,
      12,
      0,
      3,
      7,
      18,
      19,
      20,
      21,
      6,
      2,
      4,
      5,
      11,
      13,
      14,
      16,
      17
    ],
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": 7,
    "hiddenIds": [
      "custom_cc8e15cd-bf7c-43f6-ab67-f6b10d7bb159",
      "custom_e2876f4d-f7d0-4c14-bc6d-af41d28952c2",
      "custom_86857bf9-c487-4253-a566-a530683bfccd"
    ],
    "orderedIds": [
      "custom_d1120eef-4389-4d19-9532-29d807b61d5d",
      "custom_dba3cc37-fa07-4810-942d-aa21bdf5d554",
      "custom_a8fcbf74-99ea-4397-888b-bea31b5d3211",
      "custom_7a704fce-6930-45bd-97d9-90f109da4982",
      "custom_d2f748d6-ab6f-424b-96b8-71286f001dc4",
      "custom_abfc0da9-efe9-4a24-8f6a-f9b81e792e1f",
      "custom_86857bf9-c487-4253-a566-a530683bfccd",
      "custom_71be8826-be3b-42e0-aeed-f0c631ac6591",
      "custom_cc8e15cd-bf7c-43f6-ab67-f6b10d7bb159",
      "custom_e2876f4d-f7d0-4c14-bc6d-af41d28952c2"
    ],
    "hiddenIndices": [
      0,
      2,
      4
    ],
    "ordering": [
      5,
      9,
      1,
      3,
      6,
      8,
      4,
      7,
      0,
      2
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
